export class UpdateIsElligible {
  static readonly type = '[Feedback] Update Elligible';
  constructor(public isElligible: boolean) {}
}

export class UpdateHasClosedModal {
  static readonly type = '[Feedback] Update Closed Modal';
  constructor(public hasClosedModal: boolean) {}
}
